import { lazy } from 'react';

export const PlayerCancelGlobalLossLimitForm = lazy(
  () => import('./PlayerCancelGlobalLossLimitForm'),
);
